import { SVGProps } from 'react';

const IOSShareIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.695 26.006" {...props}>
		<g fill="#007AFF" fillOpacity={0.85}>
			<path d="M17.334 10.81v9.63c0 2.011-1.025 3.027-3.066 3.027H3.066C1.026 23.467 0 22.46 0 20.44v-9.63c0-2.02 1.025-3.027 3.066-3.027h2.989v1.572h-2.97c-.976 0-1.513.518-1.513 1.534v9.472c0 1.016.537 1.534 1.514 1.534h11.152c.967 0 1.524-.518 1.524-1.534V10.89c0-1.016-.557-1.534-1.524-1.534H11.27V7.783h2.998c2.04 0 3.066 1.016 3.066 3.027Z" />
			<path d="M8.662 15.82c.42 0 .781-.341.781-.752V5.137l-.058-1.455.547.576 1.503 1.611a.713.713 0 0 0 .528.235c.41 0 .713-.293.713-.684a.687.687 0 0 0-.225-.518L9.23 1.797c-.196-.195-.362-.254-.567-.254-.195 0-.361.059-.566.254L4.883 4.902c-.147.147-.235.303-.235.518 0 .39.293.684.704.684.185 0 .4-.079.537-.235l1.513-1.611.547-.576-.058 1.455v9.931c0 .41.351.752.771.752Z" />
		</g>
	</svg>
);
export default IOSShareIcon;
